import {setBearer } from "../../utils/constants";
import ClubModel from "../models/clubs";
import ContractModel from "../models/contract";
import ContractAssociatedModel from "../models/contractAssociated";
import ContractByDateModel from "../models/contractByDate";
import ContractByIdModel from "../models/contractById";
import { crewLoginRequest, fetchClubs, fetchContractsByClubId, fetchContractsByDate, findContract, findContractAssociated } from "../provider/api";

export let errorContract: String;
let idContract: string = "";
let numberContract: string = "";
let enterpriseID: string = "";
let categoryId: string = "";

export const setIdContract = (id: string) => {
    localStorage.removeItem("contracdID");
    idContract = id;
    localStorage.setItem("contracdID", id);
    console.log(localStorage.getItem("contracdID"), "ID DO CONTRATO")
};

export const setNumberContract = (id: string) => {
    localStorage.removeItem("contractNumber");
    numberContract = id;
    localStorage.setItem("contractNumber", id);
    console.log(localStorage.getItem("contractNumber"), "NUMERO DO CONTRATO")
};

export const setEnterpriseId = (id: string) => {
    enterpriseID = id;
    localStorage.setItem("enterpriseID", id);
};
  
export const getIdContract = (): string => {
    return numberContract;
};

export const setIdCategory = (categoryId: string) => {
    categoryId = categoryId;
    localStorage.setItem("categoryID", categoryId);
  };
  
export const getIdCategory = (): string => {
    return categoryId;
};

export async function crewAuth(user: String, pswd: String) {
    const responseData = await crewLoginRequest(user, pswd);

    setBearer(responseData.access_token);

    localStorage.setItem("access_token", responseData.access_token);
}

export async function getContractInfo(contractId: string): Promise<{ contract: ContractModel | null }> {
    try {
        const responseData = await findContract(contractId);
        setNumberContract(contractId);

        if (responseData.statusCode && responseData.statusCode !== 200) {
            errorContract = responseData.message;
            throw new Error(responseData.message || "Erro ao buscar contrato.");
        }

        const contract = ContractModel.fromApiResponse(responseData);

        return { contract };

    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar contrato`);
        console.log(error.toString());
        return { contract: null }; 
    }
}

export async function getContractAssociatedInfo(cnpjcpf: string): Promise<{ contract: ContractAssociatedModel | null }> {
    try {
        const responseData = await findContractAssociated(cnpjcpf);

        if (responseData.statusCode && responseData.statusCode !== 200) {
            errorContract = responseData.message;
            throw new Error(responseData.message || "Erro ao buscar contrato.");
        }

        const contract = ContractAssociatedModel.fromApiResponse(responseData);

        return { contract };

    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar contrato de associado`);
        console.log(error.toString());
        return { contract: null }; 
    }
}

export async function getClubs(): Promise<{ clubs: ClubModel[] }> {
    try {
        const responseData = await fetchClubs();

        if (responseData.statusCode && responseData.statusCode !== 200) {
            throw new Error(responseData.message || "Erro ao buscar clubes.");
        }

        const clubs = ClubModel.fromApiResponseArray(responseData);
        

        return { clubs };
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar clubes`);
        console.log(error.toString());
        return { clubs: []};
    }
}

export async function getContractById(id: string): Promise<{ contractById: ContractByIdModel[] }> {
    try {
        const responseData = await fetchContractsByClubId(id);

        if (responseData.statusCode && responseData.statusCode !== 200) {
            throw new Error(responseData.message || "Erro ao buscar contratos.");
        }

        const contractById = ContractByIdModel.fromApiResponseArray(responseData);
        

        return { contractById };
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar contratos`);
        console.log(error.toString());
        return { contractById: []};
    }
}

export async function getContractByDate(contractId: string, startDate: string, endDate: string): Promise<{ contractByDate: ContractByDateModel[] }> {
    try {
        const responseData = await fetchContractsByDate(contractId, startDate, endDate);

        if (responseData.statusCode && responseData.statusCode !== 200) {
            throw new Error(responseData.message || "Erro ao buscar contratos pela data.");
        }

        const contractByDate = ContractByDateModel.fromApiResponseArray(responseData);
        

        return { contractByDate };
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar contratos pela data`);
        console.log(error.toString());
        return { contractByDate: []};
    }
}